import { setupTurboRedirect } from "./util/turbo_redirect"
import './src/jquery'
import './src/underscore'
import './src/toastr'

import './vendor/jquery-ui'
import 'jquery-locationpicker'
import 'jquery-validation'
import 'bootstrap-switch'
import TomSelect from 'tom-select'
window.TomSelect = TomSelect

import "@hotwired/turbo-rails"
import TC from "@rolemodel/turbo-confirm"

// Import Bootstrap 3 components
import './vendor/bootstrap/tooltip'
import './vendor/bootstrap/button'
import './vendor/bootstrap/collapse'
import './vendor/bootstrap/modal'
import './vendor/bootstrap/alert'
import './vendor/bootstrap/dropdown'
import './vendor/bootstrap/tab'

// old js scripts with jquery dependency
import "./old"

import "./controllers"

document.addEventListener("DOMContentLoaded", () => {
  setupTurboRedirect()
})

// Also initialize on turbo:load for SPA navigation
document.addEventListener("turbo:load", () => {
  TC.start({
    dialogSelector: '#confirm',
    acceptSelector: '#confirm-accept',
    denySelector: '.confirm-cancel',
    activeClass: 'in',
    showConfirmCallback: (element) => {
      $(element).modal('show')
    },
    hideConfirmCallback: (element) => {
      $(element).modal('hide')
    }
  })
})
